export const CUSTOMER_LABELS = [
  {
    value: 'current_customer',
    labelKey: 'users:customerLabel.currentCustomer',
    icon: 'customer-label-cup',
    bgColor: '#199DA3',
  },
  {
    value: 'vip_customer',
    labelKey: 'users:customerLabel.vipCustomer',
    icon: 'customer-label-crown',
    bgColor: '#006C9C',
  },
  {
    value: 'churned_customer',
    labelKey: 'users:customerLabel.churnedCustomer',
    icon: 'customer-label-run',
    bgColor: '#B71D18',
  },
];

export const getCustomerLabelConfig = (label) =>
  CUSTOMER_LABELS.find((item) => item.value === label);
